import React, {ReactElement} from 'react';
import FormElementPaddingBefore from './formElementPaddingBefore';
import FormElementWidthChange from './formElementWidthChange';
import {IFormElement} from '../../../../../incase-domain/elements/base/formElementBase';

interface FormElementOptionsProps {
    highlightedElement: IFormElement;
    highlightedElementChangeHandler: {single: (field: keyof IFormElement, value: unknown) => void};
}
function FormElementOptions(props: FormElementOptionsProps): ReactElement {
    const {highlightedElement, highlightedElementChangeHandler} = props;

    return (
        <div className="l-group--form">
            <FormElementWidthChange
                width={highlightedElement.formWidth}
                changeWidth={(value: number) => {
                    highlightedElementChangeHandler.single('formWidth', value);
                }}
            />

            <FormElementPaddingBefore
                paddingBefore={highlightedElement.paddingBefore}
                changePadding={(value: number) => {
                    highlightedElementChangeHandler.single('paddingBefore', value);
                }}
            />
        </div>
    );
}

export default FormElementOptions;
